import PubSub from 'pubsub-js';

const $html = $('html');
const $header = $('.header');
const $anchorMenu = $('.anchorMenu');
const $targetParent = $('.content.-index');
const $contentArrow = $('.content__arrow', $targetParent);
const $contentCopy = $('.content__copy', $targetParent);
const $contentLeadIndex = $('.content__leadIndex', $targetParent);

PubSub.subscribe('init', () => {
  $contentCopy.addClass('-show');
  $contentLeadIndex.addClass('-show');
  $contentArrow.addClass('-show');

  $header.addClass('-show');
  $anchorMenu.addClass('-show');
});

PubSub.subscribe('top.index.show', () => {
  $contentCopy.addClass('-show');
  $contentLeadIndex.addClass('-show');
  $contentArrow.addClass('-show');
});

PubSub.subscribe('top.index.hide', () => {
  $contentCopy.removeClass('-show');
  $contentLeadIndex.removeClass('-show');
  $contentArrow.removeClass('-show');

  if ($html.hasClass('-opening')) {
    $html.removeClass('-opening');
  }
});